import words from '../../../content/generated/companions/presentation.json' with { type: 'json' };
import { findCompanionVoice, worldFacts, type StoryContent, type StorySession } from '../../../packages/sim/src/campaign/story.ts';
import { prerequisitesMet } from '../../../packages/sim/src/quests/graph.ts';
import type { Expression } from './companions.ts';

export type CompanionRemark = { key: string; speakerId: string; text: string; expression: Expression; beatId: string };
type RemarkRecipe = { id: string; beatId: string | null; otherTemplate?: string; unlessSurvivor?: boolean; prerequisites: { all: string[]; any: string[]; none: string[] }; text: string; expression: Expression };
const voices = words as Record<string, { templateId: string; remarks: RemarkRecipe[] }>;

/** A comment belongs to a living hireling, a real place and, when named, a present colleague. */
export function nextCompanionRemark(content: StoryContent, story: StorySession, seen: ReadonlySet<string>): CompanionRemark | null {
  const active = story.candidates.filter(candidate => story.companionIds.includes(candidate.person.id)
    && !story.departed.includes(candidate.person.id) && story.slice.continuity.persons[candidate.person.id]?.lifecycle === 'active');
  const facts = worldFacts(story);
  for (const candidate of active) {
    const voice = findCompanionVoice(content, candidate.person.id);
    if (!voice) continue;
    for (const remark of voices[voice.voiceId]?.remarks ?? []) {
      const key = `${candidate.person.id}:${remark.id}`;
      if (seen.has(key) || (remark.beatId && remark.beatId !== story.beatId) || !prerequisitesMet(remark.prerequisites, facts)) continue;
      if (remark.unlessSurvivor && candidate.person.id === story.legacyId) continue;
      const other = remark.otherTemplate ? active.find(person => person.person.id !== candidate.person.id && person.templateId === remark.otherTemplate) : undefined;
      if (remark.otherTemplate && !other) continue;
      return { key, speakerId: candidate.person.id, text: remark.text.replaceAll('{other}', other?.name ?? ''), expression: remark.expression, beatId: story.beatId };
    }
  }
  return null;
}
